// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Import a richiesta (lazy) per rotta: ogni vista finisce nel proprio chunk webpack,
// scaricato solo quando quella rotta viene visitata, invece di essere tutte impacchettate
// nel bundle iniziale (che prima le includeva tutte, anche quelle mai aperte in una sessione).
const LoginView = () => import('../views/LoginView.vue')
const DashboardView = () => import('../views/DashboardView_new.vue')
const CreaLegaView = () => import('../views/CreaLegaView.vue')
const AuthenticatedLayout = () => import('../layouts/AuthLayout.vue')
const GiocatoriDBView = () => import('../views/GiocatoriDBView.vue')
const LegheUtenteView = () => import('../views/LegheUtenteView.vue')
const DettaglioLegaView = () => import('../views/DettaglioLegaView.vue')
const RoseLegaView = () => import('../views/RoseLegaView.vue')
const RosaUtenteView = () => import('@/views/RosaUtenteView.vue')
const CompetizioniLegaView = () => import('@/views/CompetizioniLegaNew.vue')
const FormazioniCompetizioneView = () => import('@/views/FormazioniCompetizioneView.vue')
const ImpostazioniLegaView = () => import('@/views/ImpostazioniLegaView.vue')
const UtentiRegistratiView = () => import('@/views/UtentiRegistratiView.vue')
const AttivitaAdminView = () => import('@/views/AttivitaAdminView.vue')
const RosaUtenteAdmin = () => import('@/views/RosaUtenteAdmin.vue')
const TrasferimentiMercato = () => import('@/components/TrasferimentiMercato.vue')
const ProfiloUtenteView = () => import('@/views/ProfiloUtenteView.vue')
const SuperAdminDashboardView = () => import('@/views/SuperAdminDashboardView.vue')

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  
  {
  path: '/dashboard',
  component: AuthenticatedLayout,
  children: [
    {
      path: '',
      name: 'Dashboard',
      component: DashboardView,
      meta: { requiresAuth: true }
    },
    {
      path: 'crea-lega',
      name: 'CreaLega',
      component: CreaLegaView,
      meta: { requiresAuth: true }
    },
    {
      path: 'listone',
      name: 'GiocatoriDB',
      component: GiocatoriDBView,
      meta: { requiresAuth: true }
    },
    {
      path: 'leghe-utente',
      name: 'LegheUtente',
      component: LegheUtenteView,
      meta: { requiresAuth: true }
    },
    {
      path: 'leghe-utente/:legaId/lega/:nomeLega',
      name: 'DettaglioLegaView',
      component: DettaglioLegaView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'rose',
      name: 'RoseLegaView',
      component: RoseLegaView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'rose_utente',
      name: 'RoseUtenteView',
      component: RosaUtenteView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'competizioni',
      name: 'CompetizioniLegaView',
      component: CompetizioniLegaView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'formazioni',
      name: 'FormazioniCompetizioneView',
      component: FormazioniCompetizioneView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'impostazioni-lega',
      name: 'ImpostazioniLegaView',
      component: ImpostazioniLegaView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'utenti',
      name: 'UtentiRegistrati',
      component: UtentiRegistratiView,
      props: true,
      meta: { requiresAuth: true, requiresSuperAdmin: true }
    },
    {
      path: 'log_attivita_lega',
      name: 'AttivitaAdmin',
      component: AttivitaAdminView,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'rosa_admin',
      name: 'RosaUtenteAdmin',
      component: RosaUtenteAdmin,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'trasferimenti_mercato',
      name: ' TrasferimentiMercato',
      component: TrasferimentiMercato,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: 'profilo',
      name: 'ProfiloUtente',
      component: ProfiloUtenteView,
      meta: { requiresAuth: true }
    },
    {
      path: 'super-admin',
      name: 'SuperAdminDashboard',
      component: SuperAdminDashboardView,
      meta: { requiresAuth: true, requiresSuperAdmin: true }
    },
    /*{
      path: 'test_formazione_rosa_utente',
      name: 'test_formazione',
      component: TestFormazioneNew,
      props: true,
      meta: { requiresAuth: true }
    },*/
  ]
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Middleware globale per proteggere le rotte
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isLoggedIn
   console.log('Authenticated:', isAuthenticated)
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresSuperAdmin && !store.state.user?.is_super_admin) {
    next('/dashboard')
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard') // se sei loggato, evita di tornare al login
  } else {
    next()
  }
})

export default router
